import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ isOpen }) {
  const links = [
    { to: '/', icon: '📊', label: 'لوحة التحكم' },
    { to: '/users', icon: '👥', label: 'المستخدمين' },
    { to: '/workers', icon: '🔧', label: 'العمال' },
    { to: '/orders', icon: '📦', label: 'الطلبات' },
    { to: '/services', icon: '🧽', label: 'الخدمات' },
    { to: '/reports', icon: '📈', label: 'التقارير' },
  ];

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <span className="sidebar-logo">🚗</span>
        {isOpen && <h2>مغسلة سيارات</h2>}
      </div>
      <nav className="sidebar-nav">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/'}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{link.icon}</span>
            {isOpen && <span className="nav-label">{link.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
